import React from "react";
import styled from "styled-components";

import NanoFlex from "../Global/NanoFlex.js";

const StyledLoading = styled(NanoFlex)`
  display: flex;
  position: fixed;
  z-index: 20000;
  height: 100vh;
  align-items: center;
  justify-content: center;
  width: 100vw;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${(props) => props.theme.color.primaryColors.transparencyPurple};
  backdrop-filter: blur(3px);

  svg {
    z-index: 5;
    height: 120px;
    width: auto;
    margin-right: 25px;
    margin-top: -10px;
    position: absolute;
  }

  .circleField {
    .circle {
      position: absolute;
      background: #111;
      left: 50%;
      top: 50%;
      width: 70px;
      height: 70px;
      line-height: 100px;
      text-align: center;
      color: black;
      font-size: 40px;
      border-radius: 100%;
      margin-top: -50px;
      margin-left: -50px;
      transition: all 1s cubic-bezier(0.77, 0, 0.175, 1);
      transform: translate3d(0, 0, 0);
      background: ${(props) => props.theme.color.primaryColors.mediumYellow};
      backdrop-filter: blur(8px);
      transform-origin: 0 0;
      z-index: 1 !important;
    }
  }

  .circle:nth-child(17) {
    transform: scale(1);
    animation: wobble 8s alternate ease-in-out infinite;
  }
  @keyframes move-1 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(77.781745px, 77.781745px, 0) scale(0.33);
    }
  }
  .circle:nth-child(1) {
    animation: move-1 2s ease-in-out alternate -0.5s infinite;
  }
  @keyframes move-2 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(0px, 110px, 0) scale(0.33);
    }
  }
  .circle:nth-child(2) {
    animation: move-2 2s ease-in-out alternate -1s infinite;
  }
  @keyframes move-3 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-77.781745px, 77.781745px, 0) scale(0.33);
    }
  }
  .circle:nth-child(3) {
    animation: move-3 2s ease-in-out alternate -1.5s infinite;
  }
  @keyframes move-4 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-110px, 0px, 0) scale(0.33);
    }
  }
  .circle:nth-child(4) {
    animation: move-4 2s ease-in-out alternate -2s infinite;
  }
  @keyframes move-5 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-77.781745px, -77.781745px, 0) scale(0.33);
    }
  }
  .circle:nth-child(5) {
    animation: move-5 2s ease-in-out alternate -2.5s infinite;
  }
  @keyframes move-6 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(0px, -110px, 0) scale(0.33);
    }
  }
  .circle:nth-child(6) {
    animation: move-6 2s ease-in-out alternate -3s infinite;
  }
  @keyframes move-7 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(77.781745px, -77.781745px, 0) scale(0.33);
    }
  }
  .circle:nth-child(7) {
    animation: move-7 2s ease-in-out alternate -3.5s infinite;
  }
  @keyframes move-8 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(110px, 0px, 0) scale(0.33);
    }
  }
  .circle:nth-child(8) {
    animation: move-8 2s ease-in-out alternate -4s infinite;
  }
  @keyframes move2-9 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(14.142135px, 14.142135px, 0) scale(1.6);
    }
  }
  .circle:nth-child(9) {
    animation: move2-9 2s ease-in-out alternate -4.28571s infinite;
  }
  @keyframes move2-10 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(0px, 20px, 0) scale(1.6);
    }
  }
  .circle:nth-child(10) {
    animation: move2-10 2s ease-in-out alternate -4.7619s infinite;
  }
  @keyframes move2-11 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-14.142135px, 14.142135px, 0) scale(1.6);
    }
  }
  .circle:nth-child(11) {
    animation: move2-11 2s ease-in-out alternate -5.2381s infinite;
  }
  @keyframes move2-12 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-20px, 0px, 0) scale(1.6);
    }
  }
  .circle:nth-child(12) {
    animation: move2-12 2s ease-in-out alternate -5.71429s infinite;
  }
  @keyframes move2-13 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(-14.142135px, -14.142135px, 0) scale(1.6);
    }
  }
  .circle:nth-child(13) {
    animation: move2-13 2s ease-in-out alternate -6.19048s infinite;
  }
  @keyframes move2-14 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(0px, -20px, 0) scale(1.6);
    }
  }
  .circle:nth-child(14) {
    animation: move2-14 2s ease-in-out alternate -6.66667s infinite;
  }
  @keyframes move2-15 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(14.142135px, -14.142135px, 0) scale(1.6);
    }
  }
  .circle:nth-child(15) {
    animation: move2-15 2s ease-in-out alternate -7.14286s infinite;
  }
  @keyframes move2-16 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(20px, 0px, 0) scale(1.6);
    }
  }
  .circle:nth-child(16) {
    animation: move2-16 2s ease-in-out alternate -7.61905s infinite;
  }
  @keyframes move2-17 {
    from {
      transform: translate3d(0, 0, 0) scale(1);
    }
    to {
      transform: translate3d(14.142135px, 14.142135px, 0) scale(1.6);
    }
  }
  .circle:nth-child(17) {
    animation: move2-17 2s ease-in-out alternate -8.09524s infinite;
  }

  /* SMALL DESKTOPS */
  @media only screen and (max-width: 1450px) {
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
  }
`;

const Loading = (props) => {
  return (
    <StyledLoading className="loading">
      <svg width="244" height="151" viewBox="0 0 244 151" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M64.85 16.8501C64.65 17.0001 64.5 29.5001 64.5 44.6001C64.5 66.1501 64.65 72.0001 65.15 72.0501C67.3 72.2001 71 72.0501 71.45 71.8001C71.8 71.5501 72 67.3001 72 58.6001C72 43.5501 72.25 42.5501 76.25 40.2501C79.95 38.0501 85.6 38.6501 87.9 41.4501C90.05 44.1001 90.25 45.3501 90.5 59.0001L90.75 72.2501L92 72.3501C92.7 72.3501 94.2 72.3001 95.4 72.1501L97.5 71.8501V57.1501C97.5 42.6001 97.5 42.4501 96.3 40.1001C94.9 37.4501 92 34.3001 89.9 33.2001C85.6 30.9501 78.35 31.3501 74.6 34.0001C73.45 34.8001 72.35 35.5001 72.25 35.5001C72.1 35.5001 72 31.3501 72 26.3001C72 18.4001 71.9 17.0501 71.2 16.8001C70.15 16.4001 65.25 16.4001 64.85 16.8501Z"
          fill="#582ED1"
        />
        <path
          d="M36 32.1501C25.7 34.5501 19.15 44.7001 20.95 55.5501C22.3 63.9501 27.7 70.3501 35 72.3501C37.8 73.1001 43.8 73.1501 46.05 72.4501C51.35 70.8001 57.5 65.5501 57.5 62.8001C57.5 62.0001 53.1 59.4501 51.9 59.5501C51.55 59.5501 50.6 60.5001 49.75 61.6001C47.6 64.6001 45.05 65.7501 40.75 65.7501C36 65.7501 33.5 64.3501 30.65 60.1001C28.55 57.0001 28.5 56.8001 28.5 52.9501C28.5 44.4001 33.2 39.0001 40.7 38.9001C44 38.8501 47.4 40.2001 49.05 42.2501C49.5 42.8001 50.3 43.7501 50.85 44.4001L51.75 45.5501L54.4 44.2501C57.5 42.7001 57.85 42.1001 56.8 40.1001C55.95 38.5001 51.1 34.0001 50.25 34.0001C49.95 34.0001 48.8 33.5501 47.7 33.0501C45.1 31.7501 39.5 31.3501 36 32.1501Z"
          fill="#582ED1"
        />
        <path
          d="M118.4 32.0002C117.1 32.2002 114.8 33.0002 113.3 33.6502C110.3 35.0502 106 39.1502 106 40.6002C106 41.5502 108.4 43.3002 110.35 43.8002C111.25 44.0502 112.1 43.5502 114.25 41.5502C117.35 38.7502 119.05 38.2002 123.4 38.6502C125.85 38.9002 126.5 39.2002 127.9 40.7002C129.2 42.1502 129.5 42.9002 129.5 44.7002V46.9002L127.4 47.2502C126.2 47.4002 124.25 47.7502 123 48.0002C121.75 48.2502 119.4 48.7002 117.75 49.0002C112.55 49.9502 109.45 51.1502 107.45 53.1002C104.95 55.5002 104 57.5002 103.65 60.8002C103.15 65.7002 106.35 70.4502 111.45 72.2502C116.45 74.0002 123.35 72.9002 127.8 69.6502C129.85 68.1502 130 68.2002 130 70.2002V71.9002L133.15 72.1002C134.85 72.2002 136.4 72.2002 136.65 72.1002C136.85 72.0002 137 65.2502 137 57.1002C137 42.5002 136.95 42.2002 135.8 39.7502C132.95 33.7002 126.05 30.6002 118.4 32.0002ZM129.6 56.2002C129.45 59.3002 127.45 63.0502 125.05 64.7002C119.2 68.7002 111.5 66.9002 111.5 61.5502C111.5 57.6502 113.4 56.0502 119.25 55.0002C121.2 54.6502 123.55 54.2002 124.5 53.9502C125.45 53.7502 127.05 53.6002 128 53.6502L129.75 53.7502L129.6 56.2002Z"
          fill="#582ED1"
        />
        <path
          d="M155.45 32C146.05 33.6 141.75 43.65 147.6 50.3C149.8 52.8 151.25 53.45 160.5 56.2C166.2 57.9 167.9 59.95 166.35 63.3C164.2 67.75 156.25 67.95 152 63.6C151.05 62.55 149.85 61.2 149.45 60.5L148.65 59.25L146.05 60.45C143.1 61.85 142.9 62.6 144.7 65.45C147.65 70.1 153.45 73 159.75 73C168.45 73 174.15 68.45 174.15 61.45C174.15 55.45 170.7 52.05 161.6 49.2C154.6 47.05 152.5 45.65 152.5 43.35C152.5 40.3 155.35 38 159.1 38C161.4 38 164.75 39.8 166.65 42.05C167.6 43.1 168.75 44 169.2 44C170.5 44 174 42.05 174 41.35C174 39.75 169.6 34.85 167 33.5C165.3 32.6 160.15 31.45 158.55 31.55C158.1 31.6 156.7 31.8 155.45 32Z"
          fill="#582ED1"
        />
        <path
          d="M194.75 32C188 33.45 182.35 38.85 180.25 45.9C179.4 48.7 179.3 55.45 180.05 57.95C181.2 61.7 183.35 65.35 185.75 67.65C189.75 71.55 193.45 73 199.3 73C203.5 73 206.65 72.15 210.15 70C213.05 68.25 216.25 64.4 215.85 63.3C215.55 62.5 212 60.5 210.95 60.5C210.6 60.5 209.2 61.6 207.75 62.95C204.5 66.05 201.05 67 196.75 66.05C191.8 64.95 187.55 60.35 187.5 56.1V54.5H202.25H217L217.3 53.2C217.5 52.5 217.5 50.45 217.3 48.6C216.6 42.05 212.45 35.95 206.85 33.3C203.85 31.9 198.05 31.25 194.75 32ZM202.55 38.75C203.75 39.2 205.4 40.15 206.15 40.9C208 42.6 209.6 45.75 209.4 47.15C209.25 48.25 209.1 48.25 198.6 48.4C186.6 48.55 186.65 48.55 188.3 44.9C190.75 39.5 197 36.8 202.55 38.75Z"
          fill="#582ED1"
        />
        <path
          d="M94.4 79.4C91.8 80.9 89.65 83.55 88.25 87C87.6 88.7 87.35 90.65 87.35 94.75C87.35 100.2 87.45 100.75 90.25 110.75C92.75 119.75 91.15 128 85.2 136.35C82.1 140.65 82.2 141 86.5 141C89.75 141 90.15 140.85 91.3 139.6C92 138.85 93.6 136.2 94.8 133.7C99.05 125 99.35 117.5 95.9 105.35C93.35 96.3 93.8 88.7 96.95 85.55C97.55 84.95 98.55 84.5 99.25 84.5C101.8 84.5 102.05 87.5 100.45 98.6C98.75 110.15 99.55 115.25 103.5 117.9C108.3 121.15 116.75 116.5 122.8 107.4C124.05 105.5 125.3 104.1 125.55 104.3C125.8 104.45 126 105.8 126 107.3C126 110.95 127 116.9 127.7 117.4C128 117.65 129.6 117.7 131.25 117.55C134.7 117.2 134.5 118.05 133.6 109.35C132.95 103.15 133.45 94.9 135 85.65C135.55 82.5 136 79.7 136 79.45C136 79.2 134.45 79 132.5 79H129.05L128.5 81.1C126.15 90.3 122.05 99.4 117.45 105.5C113.85 110.25 111.65 112 109.3 112C106.5 112 106.45 111.15 108.55 93.3C109.8 82.4 107.35 78 100 78C97.35 78 96.3 78.25 94.4 79.4Z"
          fill="#582ED1"
        />
        <path
          d="M165.5 78.9998C164 79.5498 161.25 80.9998 159.4 82.2498C157.55 83.4998 155.95 84.4998 155.85 84.4998C155.75 84.4998 155.4 83.2498 155.05 81.7498L154.45 78.9998H151.25C149.5 78.9998 147.95 79.1998 147.75 79.4498C147.6 79.6998 147.95 81.9498 148.5 84.4498C149.85 90.5498 149.8 91.1498 147.55 94.6998C144.85 98.9998 143.15 102.45 141.75 106.65C139.75 112.35 139.6 113 139 117.8C138.05 125.25 139.8 131.35 143.35 132.95C147.35 134.8 152 134 154.7 131C157.75 127.6 158.75 123.35 158.7 113.5C158.7 108.95 158.3 102.3 157.85 98.7498L157.05 92.2498L159 90.2498C162.2 86.9998 166 84.9498 169.45 84.6498C173.2 84.2998 174.55 84.6498 176.75 86.5498C179.95 89.3998 181.3 96.2998 179.8 102.5C178.85 106.4 177.85 108.15 175.25 110.3C173.05 112.05 172.75 112.15 169.35 112.15C167.35 112.15 165.25 111.9 164.65 111.6C164.05 111.25 163.25 111.1 162.9 111.25C162.05 111.6 160.95 116.55 161.55 117.3C161.75 117.55 163.45 118.1 165.25 118.45C174.15 120.25 181.9 116.2 185.75 107.75C187.75 103.45 188.35 98.0998 187.45 92.4998C186.45 85.9498 183.65 81.7498 178.75 79.4498C175 77.6498 169.8 77.4998 165.5 78.9998ZM153.8 110.65C154.15 118.95 153.65 123 151.9 125.85C150.8 127.7 149.1 128.05 148.2 126.6C146 123.1 147.85 110.5 151.65 103.15C152.6 101.25 152.8 101.15 153.1 102.05C153.3 102.6 153.65 106.5 153.8 110.65Z"
          fill="#582ED1"
        />
        <path d="M190.4 111.15C189.7 111.8 188.95 112.85 188.75 113.45C188 115.9 190.65 119 193.5 119C195.15 119 197.5 116.35 197.5 114.5C197.5 113.4 197.05 112.45 196.05 111.45C194.2 109.65 192.15 109.55 190.4 111.15Z" fill="#582ED1" />
      </svg>
      <NanoFlex className="circleField">
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
        <NanoFlex className="circle"></NanoFlex>
      </NanoFlex>
    </StyledLoading>
  );
};

export default Loading;

// --- // Documentation // --- //
/*

import Loading from './../Nano/Loading.js';

<Loading />
*/
